var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.9974V4.33073C13.3333 3.39731 13.3333 2.9306 13.1517 2.57408C12.9919 2.26047 12.7369 2.00551 12.4233 1.84572C12.0668 1.66406 11.6001 1.66406 10.6667 1.66406H9.33333C8.39991 1.66406 7.9332 1.66406 7.57668 1.84572C7.26308 2.00551 7.00811 2.26047 6.84832 2.57408C6.66667 2.9306 6.66667 3.39731 6.66667 4.33073V4.9974M8.33333 9.58073V13.7474M11.6667 9.58073V13.7474M2.5 4.9974H17.5M15.8333 4.9974V14.3307C15.8333 15.7309 15.8333 16.4309 15.5608 16.9657C15.3212 17.4361 14.9387 17.8186 14.4683 18.0582C13.9335 18.3307 13.2335 18.3307 11.8333 18.3307H8.16667C6.76654 18.3307 6.06647 18.3307 5.53169 18.0582C5.06129 17.8186 4.67883 17.4361 4.43915 16.9657C4.16667 16.4309 4.16667 15.7309 4.16667 14.3307V4.9974",
    stroke: "#D90429",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash-red.9ce42c395d2fb2d5261d8ba35c790982.svg";
export { ForwardRef as ReactComponent };